module.exports = __webpack_public_path__ + "img/pc.161558c0.png";